import projectData from "../../assets/data/project-data.json";
import imageManifest from "../../assets/data/project-images.json";

// Joins project-data.json with the manifest written by `npm run images`.
// Photos missing from the manifest are skipped rather than rendered broken.
export const projects = projectData
  .map((project) => {
    const entry = imageManifest[project.title];
    if (!entry) return null;
    const images = project.images
      .map((file) => entry.images[file] && { file, ...entry.images[file] })
      .filter(Boolean);
    if (images.length === 0) return null;
    return { ...project, slug: entry.slug, images };
  })
  .filter(Boolean);

export const categories = [...new Set(projects.map((p) => p.projectCategory).filter(Boolean))];

// Optional fields are shown only when filled in.
export const projectMeta = (project) =>
  [
    ["Client", project.client],
    ["Location", project.location],
    ["Year", project.year],
    ["Value", project.value],
    ["Scope", project.scope],
  ].filter(([, value]) => value && String(value).trim());

export const isInProgress = (project) => /progress/i.test(project.status || "");

export const imageUrl = (project, image, width, ext) =>
  `${process.env.PUBLIC_URL}/images/projects/${project.slug}/${image.base}-${width}.${ext}`;

export const srcSet = (project, image, ext) =>
  image.widths.map((w) => `${imageUrl(project, image, w, ext)} ${w}w`).join(", ");
